import { useQuery } from '@tanstack/react-query';

import { getFeaturePermissions } from '../endpoints/permissions';
import { retryServerOutages, serverOutageRetryDelay } from '../retry';

export const useFeaturePermissionsQuery = (enabled: boolean) =>
    useQuery({
        queryKey: ['permissions', 'features'],
        queryFn: getFeaturePermissions,
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        retry: retryServerOutages,
        retryDelay: serverOutageRetryDelay,
    });
